import { defineStore } from 'pinia';

// interface Rule {
//   name: string;
//   conditions: any[];
//   actions: any[];
//   entity: string;
// }

// interface FieldPermissionRules {
//   [key: string]: Rule;
// }

export const useFieldPermissionRulesStore = defineStore('fieldPermissionRules', {
  state: () => ({
    fieldPermissionRules: {},
    originalFieldPermissionRulesStr: '{}'
  }),

  actions: {
    // 生成唯一key
    generateKey() {
      return 'rule_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    },

    // 添加新规则
    addRule(rule) {
      const key = this.generateKey();
      this.fieldPermissionRules = {
        [key]: rule,
        ...this.fieldPermissionRules
      };
      return key;
    },

    // 首屏批量添加规则，覆盖
    addRules(rules) {
      const result = {};
      rules?.forEach((rule) => {
        const key = this.generateKey();
        // this.fieldPermissionRules[key] = {
        //   ...rule
        // };
        result[key] = rule;
      });
      this.fieldPermissionRules = result;
      return result;
    },

    saveAsOriginalFieldPermissionRules() {
      this.originalFieldPermissionRulesStr = JSON.stringify(this.fieldPermissionRules);
    },
    // 检查规则是否被修改
    isRulesModified() {
      return JSON.stringify(this.fieldPermissionRules) !== this.originalFieldPermissionRulesStr;
    },

    // 更新规则
    updateRule(key, rule) {
      if (this.fieldPermissionRules[key]) {
        this.fieldPermissionRules[key] = {
          ...rule
        };
        return true;
      }
      return false;
    },

    // 删除规则
    deleteRule(key) {
      if (this.fieldPermissionRules[key]) {
        delete this.fieldPermissionRules[key];
        return true;
      }
      return false;
    },

    // 批量删除规则
    deleteRules(keys) {
      keys.forEach((key) => {
        if (this.fieldPermissionRules[key]) {
          delete this.fieldPermissionRules[key];
        }
      });
      return true;
    },

    // 获取所有规则
    getRules() {
      return this.fieldPermissionRules;
    },

    // 获取单个规则
    getRule(key) {
      return this.fieldPermissionRules[key];
    },

    // 更新规则状态
    updateRuleStatus(key, status) {
      this.fieldPermissionRules[key].status = status;
    }
  }
});

export default useFieldPermissionRulesStore;
